module.exports = __webpack_public_path__ + "static/img/A5.ff2f0e47.jpg";